<template>
  <div class="row">
    <div class="col-md-4 reports-tab-container">
      <div class="row">
        <div class="col-md-8">
          <label class="report-label">{{ $t('reports.sales.date_range') }}</label>
          <base-select
            v-model="selectedRange"
            :options="dateRange"
            :allow-empty="false"
            :show-labels="false"
            @input="onChangeDateRange"
          />
          <span v-if="$v.range.$error && !$v.range.required" class="text-danger"> {{ $t('validation.required') }} </span>
        </div>
      </div>
      <div class="row report-fields-container">
        <div class="col-md-6 report-field-container">
          <label class="report-label">{{ $t('reports.sales.from_date') }}</label>
          <base-date-picker
            v-model="formData.from_date"
            :invalid="$v.formData.from_date.$error"
            :calendar-button="true"
            calendar-button-icon="calendar"
            @change="$v.formData.from_date.$touch()"
            @input="setRangeToCustom"
          />
          <span v-if="$v.formData.from_date.$error && !$v.formData.from_date.required" class="text-danger"> {{ $t('validation.required') }} </span>
        </div>
        <div class="col-md-6 report-field-container">
          <label class="report-label">{{ $t('reports.sales.to_date') }}</label>
          <base-date-picker
            v-model="formData.to_date"
            :invalid="$v.formData.to_date.$error"
            :calendar-button="true"
            calendar-button-icon="calendar"
            @change="$v.formData.to_date.$touch()"
            @input="setRangeToCustom"
          />
          <span v-if="$v.formData.to_date.$error && !$v.formData.to_date.required" class="text-danger"> {{ $t('validation.required') }} </span>
        </div>
      </div>
      <div class="row report-submit-button-container">
        <div class="col-md-6">
          <base-button outline color="theme" class="report-button" @click="getReports()">
            {{ $t('reports.update_report') }}
          </base-button>
        </div>
      </div>
    </div>
    <div class="col-sm-8 reports-tab-container">
      <iframe :src="getReportUrl" class="reports-frame-style" />
      <a class="base-button btn btn-primary btn-lg report-view-button" @click="viewReportsPDF">
        <font-awesome-icon icon="file-pdf" class="vue-icon icon-left svg-inline--fa fa-download fa-w-16 mr-2" />
        <span>{{ $t('reports.view_pdf') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import { validationMixin } from 'vuelidate'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
const { required } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      dateRange: [
        'Today',
        'This Week',
        'This Month',
        'This Quarter',
        'This Year',
        'Previous Week',
        'Previous Month',
        'Previous Quarter',
        'Previous Year',
        'Custom'
      ],
      selectedRange: 'This Month',
      range: new Date(),
      formData: {
        from_date: moment().startOf('month').toString(),
        to_date: moment().endOf('month').toString()
      },
      url: null,
      siteURL: null,
      isDownloading: false
    }
  },
  validations: {
    range: {
      required
    },
    formData: {
      from_date: {
        required
      },
      to_date: {
        required
      }
    }
  },
  computed: {
    ...mapGetters('company', [
      'getSelectedCompany'
    ]),
    getReportUrl () {
      return this.url
    }
  },
  mounted () {
    this.siteURL = `/reports/CN-profit-share/${this.getSelectedCompany.unique_hash}`
    this.getInitialReport()
  },
  methods: {
    getThisDate (type, time) {
      return moment()[type](time).toString()
    },
    getPreDate (type, time) {
      return moment().subtract(1, time)[type](time).toString()
    },
    onChangeDateRange () {
      switch (this.selectedRange) {
        case 'Today':
          this.formData.from_date = moment().toString()
          this.formData.to_date = moment().toString()
          break
        case 'This Week':
          this.formData.from_date = this.getThisDate('startOf', 'isoWeek')
          this.formData.to_date = this.getThisDate('endOf', 'isoWeek')
          break
        case 'This Month':
          this.formData.from_date = this.getThisDate('startOf', 'month')
          this.formData.to_date = this.getThisDate('endOf', 'month')
          break
        case 'This Quarter':
          this.formData.from_date = this.getThisDate('startOf', 'quarter')
          this.formData.to_date = this.getThisDate('endOf', 'quarter')
          break
        case 'This Year':
          this.formData.from_date = this.getThisDate('startOf', 'year')
          this.formData.to_date = this.getThisDate('endOf', 'year')
          break
        case 'Previous Week':
          this.formData.from_date = this.getPreDate('startOf', 'isoWeek')
          this.formData.to_date = this.getPreDate('endOf', 'isoWeek')
          break
        case 'Previous Month':
          this.formData.from_date = this.getPreDate('startOf', 'month')
          this.formData.to_date = this.getPreDate('endOf', 'month')
          break
        case 'Previous Quarter':
          this.formData.from_date = this.getPreDate('startOf', 'quarter')
          this.formData.to_date = this.getPreDate('endOf', 'quarter')
          break
        case 'Previous Year':
          this.formData.from_date = this.getPreDate('startOf', 'year')
          this.formData.to_date = this.getPreDate('endOf', 'year')
          break
        default:
          break
      }
    },
    setRangeToCustom () {
      this.selectedRange = 'Custom'
    },
    async getInitialReport () {
      this.url = `${this.siteURL}?from_date=${moment(this.formData.from_date).format('DD/MM/YYYY')}&to_date=${moment(this.formData.to_date).format('DD/MM/YYYY')}`
    },
    async viewReportsPDF () {
      await this.getReports()
      window.open(this.getReportUrl, '_blank')
    },
    async getReports () {
      this.$v.range.$touch()
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return false
      }
      this.url = `${this.siteURL}?from_date=${moment(this.formData.from_date).format('DD/MM/YYYY')}&to_date=${moment(this.formData.to_date).format('DD/MM/YYYY')}`
      return true
    },
    async downloadReport () {
      this.$v.range.$touch()
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.isDownloading = true
      try {
        const response = await window.axios.get('/api/funder/reports/profit-share', {
          params: {
            from_date: moment(this.formData.from_date).format('DD/MM/YYYY'),
            to_date: moment(this.formData.to_date).format('DD/MM/YYYY')
          }
        })

        const rows = response.data.data

        const headers = [
          'Invoice Date',
          'Invoice Due Date',
          'Supplier Name',
          'Bank',
          'Status',
          'Buyer Name',
          'System Generated #',
          'Invoice Ref No.',
          'Prepayment',
          'Disbursement Date',
          'Borrowing Days',
          'Margin Ratio',
          'Loanable Amount',
          'Invoice Amount',
          'Offer Amount',
          'Discount',
          'Payment Amount',
          'RTGS',
          'Payment Date',
          'Kibor',
          'Spread',
          'LD Number',
          'Rate of Prepayment',
          'K Amount',
          'S Amount',
          'CN Share %',
          'CN Amount'
        ]

        const dataRows = rows.map(r => [
          r.invoice_date,
          r.due_date,
          r.supplier_name,
          r.bank,
          r.status,
          r.buyer_name,
          r.invoice_number,
          r.reference_number,
          r.prepayment,
          r.disbursement_date,
          r.borrowing_days,
          r.margin_ratio,
          r.loanable_amount,
          r.invoice_amount,
          r.offer_amount,
          r.discount,
          r.payment_amount,
          r.rtgs,
          r.payment_date,
          r.kibor,
          r.spread,
          r.ld_number,
          r.rate_of_prepayment,
          r.k_amount,
          r.s_amount,
          r.cn_share_pct,
          r.cn_amount
        ])

        const worksheetData = [headers, ...dataRows]
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)

        // Style header row
        const headerRange = XLSX.utils.decode_range(worksheet['!ref'])
        for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
          const cellRef = XLSX.utils.encode_cell({ r: 0, c: col })
          if (!worksheet[cellRef]) continue
          worksheet[cellRef].s = {
            font: { bold: true },
            fill: { fgColor: { rgb: '2C5F8A' } }
          }
        }

        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Profit Share Report')

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })

        const fromDate = moment(this.formData.from_date).format('YYYY-MM-DD')
        const toDate = moment(this.formData.to_date).format('YYYY-MM-DD')
        saveAs(blob, `CN-Profit-Share-Report_${fromDate}_${toDate}.xlsx`)

        window.toastr['success']('Excel file downloaded successfully')
      } catch (error) {
        console.error('Error downloading Excel:', error)
        window.toastr['error']('Failed to download Excel file')
      } finally {
        this.isDownloading = false
      }
    }
  }
}
</script>
